import * as React from "react";
const SvgBesttigen = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="Bestätigen">
    <path
      fill="currentColor"
      d="M128 243.54c-63.71 0-115.54-51.83-115.54-115.54S64.29 12.46 128 12.46 243.54 64.29 243.54 128 191.71 243.54 128 243.54m0-216.08C72.56 27.46 27.46 72.56 27.46 128S72.56 228.54 128 228.54 228.54 183.44 228.54 128 183.44 27.46 128 27.46"
    />
    <path
      fill="currentColor"
      d="m106.39 172.18-34.05-33.24c-2.96-2.89-3.02-7.64-.13-10.61 2.89-2.96 7.64-3.02 10.61-.13l28.7 28.01 65.66-66.94c2.9-2.96 7.65-3 10.61-.1s3 7.65.1 10.61l-70.9 72.28c-2.9 2.95-7.63 3-10.59.12Z"
    />
  </svg>
);
export default SvgBesttigen;
